import { select } from "d3";
import _L from "../../../../util/Labels";
import { TModalToALongProccessItem_ValidationResult } from "../../../controlD3/ModalThings/ModalToALongProccess";
import { Table } from "../../../controlD3/Tabla";
import { UIUtilFormat } from "../../../util/Format";
import { UIUtilGeneral } from "../../../util/Util";
import { AlumnoEdoCtaUtil } from "../AlumnoEdoCtaUtil";
import { AlEdoCtaPagoFormUtil } from "./Util";

type IItemCargoPago = AlEdoCtaPagoFormUtil.IItemCargoPago;

export class ProcesoPago2PartialPaymentView {
    private container: HTMLDivElement;
    private ctrlTblPagosParciales: Table.Tabla<IItemCargoPago>

    public get _Node(): HTMLDivElement {
        return this.container;
    }

    public get _CtrlTblPagosParciales(): Table.Tabla<IItemCargoPago> {
        return this.ctrlTblPagosParciales;
    }

    constructor(
        private procesoPagoData: AlEdoCtaPagoFormUtil.IDataForm,
    ) {
        this.container = document.createElement("div");
        this.container.className = "proceso_pago2_partial_payment_view_container";
    }


    public _DrawView(): HTMLDivElement {
        const content = select(this.container);

        content
            .classed(UIUtilGeneral.FBoxOrientation.Vertical, true)
            .style("row-gap", "10px")
            .append("label")
            .text(_L("panelfinanzasedocuenta.tag_confirmpays"));

        const fnValidaInputPagoUI = (itemPago: IItemCargoPago, inputBox: TSelectionHTML<"div">, cellContent: TSelectionHTML<"div">) => {
            let resValidation = AlumnoEdoCtaUtil.GetPagoValidation(itemPago.Pago, itemPago.Cargo);

            // inputBox.classed("input_err", !resValidation.IsValid);

            if (resValidation.IsValid) {
                cellContent.select(".lbl_error").remove();
                // mt.Notificator.fn_Mostrar(resValidation.Message, "ADVERTENCIA");
            } else {
                let lblError = cellContent.select(".lbl_error");

                if (!lblError.node()) {
                    lblError = cellContent.append("label")
                        .attr("class", "lbl_error")
                        .style("color", "red")
                        .style("cursor", "pointer")
                        .style("font-size", "calc(var(--fontsize_me4) - 2px)");
                }

                lblError
                    .on("click", () => {
                        let pagoEsperadoFixer: number;

                        if (resValidation.TypeFix == "minrecargo") {
                            pagoEsperadoFixer = itemPago.Cargo._CalcularAdeudoRecargoPendiente();
                        } else {
                            pagoEsperadoFixer = itemPago.Cargo._ObtenerSaldoFinal();
                        }

                        itemPago.Pago = pagoEsperadoFixer;
                        inputBox.select("input")
                            .property("value", pagoEsperadoFixer);

                        fnValidaInputPagoUI(itemPago, inputBox, cellContent);
                    })
                    .text(resValidation.Message);
            }
        }

        this.ctrlTblPagosParciales = new Table.Tabla<IItemCargoPago>({
            IdTabla: "AlumnosPanelEstadoCuenta-PayPagosParciales",
            Parent: content,
            IdData: "" as any,
            MinWidth: 580,
            HideCheckboxes: true,
            Resizable: false,
            RenderColumnHeadings: [
                { Field: "Periodo" as any, Label: _L("panelfinanzasedocuenta.tag_perioddesc"), IsSortable: false, MinWidth: "120px", Width: "50%" },
                { Field: "Saldo" as any, Label: _L("panelfinanzasedocuenta.tag_debe"), IsSortable: false, MinWidth: "90px", Width: "25%" },
                { Field: "Pago" as any, Label: _L("panelfinanzasedocuenta.tag_montopay"), IsSortable: false, MinWidth: "90px", Width: "25%" },
            ],
            OnValueSelectRow: (id, datum) => {
                console.log(id, datum);
            },
            EvaluatorAndSubLevelsBuild: {
                OnStepRowTable: (itemCargo, tr) => {
                    tr
                        .classed("cargo_" + itemCargo.Cargo.Id, true)
                        .style("border-bottom", "none");
                },
                OnStepCellTable: (container, datum, field) => {
                    const saldo = datum.Cargo._ObtenerSaldoFinal();

                    switch (field) {
                        case "Periodo":
                            container.classed(UIUtilGeneral.FBoxOrientation.Vertical, true);
                            container.html(`
                                                            <span id="periodo">${_L("panelfinanzasedocuenta.tag_period")}: ${datum.Cargo.Periodo}</span>
                                                            <span id="descripcion">${_L("panelfinanzasedocuenta.tag_descript")}: ${datum.Cargo.Cargo}</span>
                                                        `);
                            break;
                        case "Saldo":
                            container.text(UIUtilFormat._CurrencyFmt(saldo))
                            break;
                        case "Pago":
                            let inputC = container.select<HTMLDivElement>(".input_content");

                            if (!inputC.node()) {
                                inputC = container
                                    .style("width", "100%")
                                    .html(`<div class="input_content input_currency"></div>`)
                                    .select<HTMLDivElement>(".input_content")
                                    .style("position", "relative");

                                inputC.append<HTMLInputElement>("input")
                                    .attr("type", "number")
                                    .attr("step", ".01");
                                inputC.append("div")
                                    .attr("class", "input_symbol")
                                    .append("span")
                                    .text("$");
                            }
                            const inputPagar = inputC.select<HTMLInputElement>("input")
                                .attr("min", datum.Cargo._CalcularAdeudoRecargoPendiente())
                                .attr("max", saldo)
                                .property("value", datum.Pago)
                                .node()

                            const handleChange = (e: Event) => {
                                datum.Pago = (e.target as HTMLInputElement).valueAsNumber;

                                if (isNaN(datum.Pago)) {
                                    datum.Pago = 0;
                                    (e.target as HTMLInputElement).value = "0";
                                }

                                fnValidaInputPagoUI(datum, inputC, container);
                            };

                            inputPagar.onchange = handleChange;
                            inputPagar.onkeyup = handleChange;

                            fnValidaInputPagoUI(datum, inputC, container);
                            break;
                        // return false;
                    }
                }
            }
            // OnStepDelayedItemRowTableV2: (rowBody, tr) => {return true;},
            // OnStepItemTableV2: (container, datum, field, index) => {}
        });

        return this.container;
    }

    public _Valide(): TModalToALongProccessItem_ValidationResult {
        const procesoPagoData = this.procesoPagoData;
        let isValid = true;
        let message: string;

        for (let cargoAPagar of procesoPagoData.CargosToPay) {
            let resValidation = AlumnoEdoCtaUtil.GetPagoValidation(cargoAPagar.Pago, cargoAPagar.Cargo);

            if (!resValidation.IsValid) {
                isValid = resValidation.IsValid;
                message = resValidation.Message;

                this.ctrlTblPagosParciales._Control
                    .select(".rbodyB")
                    .select<HTMLTableRowElement>(".cargo_" + cargoAPagar.Cargo.Id)
                    .node()
                    ?.scrollIntoView({
                        block: "center",
                        behavior: "smooth"
                    });
                break;
            }
        }

        return {
            IsValid: isValid,
            Message: message
        }
    }
}